import { Check } from 'lucide-react';
import { PRICING_PLANS } from '@/lib/constants';
import { usePopup } from '@/lib/PopupContext';

export default function PricingSection() {
  const { openPopup } = usePopup();

  return (
    <section className="py-24 md:py-32 bg-white" data-testid="pricing-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#002FA7] mb-3">Pricing</p>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl tracking-tight text-[#09090B] leading-tight">
            Choose Your Protection Plan
          </h2>
          <p className="text-base md:text-lg text-zinc-600 mt-4 max-w-2xl mx-auto font-body">
            Select the package that best fits your brand protection needs. All plans include professional filing with the USPTO.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-[#E4E4E7]" data-testid="pricing-grid">
          {PRICING_PLANS.map((plan, idx) => (
            <div
              key={idx}
              className={`pricing-col border border-[#E4E4E7] p-6 flex flex-col relative ${
                plan.recommended ? 'bg-[#FAFAFA] border-t-4 border-t-[#002FA7]' : ''
              }`}
              data-testid={`pricing-plan-${plan.name.toLowerCase()}`}
            >
              {plan.recommended && (
                <span className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#002FA7] text-white text-xs font-bold uppercase tracking-wider px-4 py-1">
                  Recommended
                </span>
              )}

              <div className="mb-6">
                <h3 className="font-heading font-bold text-lg text-[#09090B] mb-2">{plan.name}</h3>
                <div className="flex items-baseline gap-1">
                  <span className="font-heading font-black text-3xl text-[#09090B]">{plan.price}</span>
                </div>
                <p className="text-xs text-zinc-500 mt-1 font-body">{plan.suffix}</p>
              </div>

              <div className="flex-1 overflow-y-auto max-h-[280px] mb-6">
                <ul className="space-y-2.5">
                  {plan.features.map((feat, fi) => (
                    <li key={fi} className="flex items-start gap-2.5 text-sm text-zinc-600 font-body py-0.5">
                      <Check className="w-4 h-4 text-[#002FA7] shrink-0 mt-0.5" />
                      <span>{feat}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <p className="text-xs text-zinc-400 mb-4 font-body">{plan.note}</p>

              <button
                onClick={() => openPopup(plan.name, parseInt(plan.price.replace('$', '')))}
                className={`w-full py-3 font-bold text-sm tracking-widest uppercase transition-colors ${
                  plan.recommended
                    ? 'bg-[#002FA7] text-white hover:bg-[#002480]'
                    : 'bg-transparent text-[#09090B] border border-[#09090B] hover:bg-[#F4F4F5]'
                }`}
                data-testid={`pricing-btn-${plan.name.toLowerCase()}`}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
